export const mockUser = {
  isLogin: false,
  name: "未登录",
  mobile: "",
  pointsBalance: 0,
  avatar:
    "https://dummyimage.com/96x96/2d2d2d/ffffff.png&text=1"
};

export const mockProjects = [
  {
    id: 1,
    title: "古风对话短片",
    cover: "https://dummyimage.com/320x180/303030/fff.png&text=1",
    updateText: "5天前",
    ratio: "16:9",
    type: "剧情演绎"
  },
  {
    id: 2,
    title: "校园悬疑片段",
    cover: "https://dummyimage.com/320x180/373737/fff.png&text=2",
    updateText: "2天前",
    ratio: "9:16",
    type: "旁白解说"
  },
  {
    id: 3,
    title: "职场反转剧情",
    cover: "https://dummyimage.com/320x180/3f3f3f/fff.png&text=3",
    updateText: "49分钟前",
    ratio: "16:9",
    type: "剧情演绎"
  }
];

export const mockAssets = {
  image: [
    { id: 11, name: "角色定妆图A", cover: "https://dummyimage.com/280x180/333/eee.png&text=1" },
    { id: 12, name: "古风街景图", cover: "https://dummyimage.com/280x180/2f2f2f/eee.png&text=2" }
  ],
  video: [
    { id: 21, name: "分镜片段#1", cover: "https://dummyimage.com/280x180/3a3a3a/eee.png&text=1", duration: "00:12" },
    { id: 22, name: "成片预览#2", cover: "https://dummyimage.com/280x180/444/eee.png&text=2", duration: "00:28" }
  ]
};

export const mockOrders = [
  { id: "OD20260416001", scene: "多角色短剧生成", amount: "¥59.00", status: "已完成", time: "2026-04-16 10:22:31" },
  { id: "OD20260415013", scene: "脚本整理", amount: "¥12.00", status: "已完成", time: "2026-04-15 15:36:08" },
  { id: "OD20260415002", scene: "视频生成", amount: "¥199.00", status: "处理中", time: "2026-04-15 09:12:14" }
];

